import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Garde-fou RBAC : si l'utilisateur n'a pas un des scopes requis, la page
// n'est même pas rendue (pas juste visuellement cachée) — redirection
// silencieuse vers la vue d'ensemble, exactement comme le comportement
// demandé pour le menu ("ne pas afficher carrément les entrées non permises").
export function ProtectedRoute({ scopes, children }: { scopes: string[]; children: React.ReactNode }) {
  const { canAny } = useAuth();
  if (!canAny(scopes)) return <Navigate to="overview" replace />;
  return <>{children}</>;
}
